// Music card — no custom logic. Spotify embed handles everything.
